import { render, staticRenderFns } from "./EmployeeInput.vue?vue&type=template&id=5c4a91b9&scoped=true&"
import script from "./EmployeeInput.vue?vue&type=script&lang=js&"
export * from "./EmployeeInput.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeInput.vue?vue&type=style&index=0&id=5c4a91b9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4a91b9",
  null
  
)

export default component.exports